// Composable para gestión de lista de satélites Starlink con Composition API (Vue 2.7+)
import { ref, computed } from 'vue'
import axios from '../plugins/axios'
import moment from 'moment'

export function useSatelliteStarlink() {
  const findTxt = ref("")
  const statusSelect = ref(['SupportedSL'])
  const statusItems = ['Supported', 'Future', 'Experimental', 'Inactive']
  const freqSelect = ref(['137'])
  const freqItems = ['137','433','868-915','2400']
  const origData = ref([])
  const loadingSatellites = ref(false)

  const headers = [
    { text: 'Name', align: 'start', value: 'displayName', class: 'font-weight-bold' },
    { text: 'Confirmed Packets', value: 'confirmedPackets', align: 'end' },
    { text: 'Frames', value: 'frames', align: 'end' },
    { text: 'Last Packet', value: 'lastPacketTime', align: 'start' },
    { text: 'Launch Date', value: 'launchDate', align: 'start' },
    { text: 'Configurations', value: 'configurations', sortable: false, align: 'start', width: '30%' },
  ]

  async function getSatellites() {
    loadingSatellites.value = true
    try {
      const { data } = await axios.get('/v1/satellites')
      origData.value = data
    } catch (error) {
      console.error("Error fetching satellites:", error)
      origData.value = []
    } finally {
      loadingSatellites.value = false
    }
  }

  function formatLaunchDate(date) {
    if (!date) return 'N/A'
    return moment(date).format('MMMM Do YYYY, H:mm:ss')
  }

  function formatConfigurations(configurations) {
    if (!configurations || configurations.length === 0) {
      return 'N/A'
    }
    return configurations.map(conf => `${conf.mode}@${conf.freq}MHz`).join(', ')
  }

  const satellites = computed(() => {
    if (!origData.value || origData.value.length === 0) return []

    let sats = [...origData.value]

    // Filtro por frames >= 10
    sats = sats.filter(s => s.frames >= 10)

    // Filtro por lastPacketTime en los últimos 365 días
    const daysAgo = moment().subtract(365, 'days')
    sats = sats.filter(s => {
      if (!s.lastPacketTime) return false
      return moment(s.lastPacketTime).isAfter(daysAgo)
    })

    // Filtro de texto
    if (findTxt.value) {
      const lowerFindTxt = findTxt.value.toLowerCase()
      sats = sats.filter(s =>
        s.name.toLowerCase().includes(lowerFindTxt) ||
        s.displayName.toLowerCase().includes(lowerFindTxt) ||
        (s.longDescription && s.longDescription.toLowerCase().includes(lowerFindTxt))
      )
    }

    // Filtro por status
    if (statusSelect.value.length > 0) {
      sats = sats.filter(sat => statusSelect.value.includes(sat.status))
    }

    // Filtro por frecuencia
    if (freqSelect.value.length > 0) {
      sats = sats.filter(sat => {
        return freqSelect.value.some(selectedFreqValue => {
          let freq_min, freq_max
          const selectedFreqStr = String(selectedFreqValue)
          if (selectedFreqStr === '137') {
            freq_min = 130; freq_max = 300
          } else if (selectedFreqStr === '433') {
            freq_min = 400; freq_max = 550
          } else if (selectedFreqStr === '868-915') {
            freq_min = 800; freq_max = 950
          } else if (selectedFreqStr === '2400') {
            freq_min = 2100; freq_max = 2500
          } else {
            return false
          }
          return sat.configurations.some(conf => conf.freq > freq_min && conf.freq < freq_max)
        })
      })
    }

    return sats
  })

  return {
    findTxt,
    statusSelect,
    statusItems,
    freqSelect,
    freqItems,
    origData,
    loadingSatellites,
    headers,
    getSatellites,
    formatLaunchDate,
    formatConfigurations,
    satellites
  }
}